import axios from "axios";
import React from "react";

export const getDbHeaders = (token) => {
  return {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
};
const getContentLength = (jsonObject) => {
  const jsonString = JSON.stringify(jsonObject);
  // Encodes the JSON string as UTF-8 and calculates the byte length
  return new TextEncoder().encode(jsonString).length;
};
const updateHeadersWithContentLength = (dbHeaders, data) => {
  const contentLength = getContentLength(data);
  return {
    ...dbHeaders,
    headers: {
      ...dbHeaders.headers,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
};
export function additionalQueryFeatures(query, fieldList, ordering, customOrdering, defaultId, defaultIdName) {
  if (!query && defaultId && defaultIdName) {
    query = defaultIdName + "=" + defaultId;
  }
  if (query && fieldList) {
    query = query + "&fields=" + fieldList;
  }
  if (query && ordering) {
    query = query + "&ordering=" + ordering;
  }
  if (query && customOrdering) {
    query = query + "&c_ordering=" + customOrdering;
  }
  return query;
}
export function getAnimoAPI(dbUrl, dbHeaders, apiName, query, fieldList, ordering, customOrdering, defaultId, defaultIdName) {
  return new Promise((resolve) => {
    query = additionalQueryFeatures(query, fieldList, ordering, customOrdering, defaultId, defaultIdName);
    if (query) {
      axios
        .get(dbUrl + `${apiName}/?${query}`, dbHeaders)
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          } else resolve(null);
        })
        .catch((error) => {
          resolve(error);
        });
    } else resolve(null);
  });
}
export function getAnimoAPIToSelect(dbUrl, dbHeaders, apiName, query, fieldList, ordering, customOrdering, defaultId, defaultIdName, valueProp, labelProp) {
  return new Promise((resolve) => {
    query = additionalQueryFeatures(query, fieldList, ordering, customOrdering, defaultId, defaultIdName);
    if (query) {
      axios
        .get(dbUrl + `${apiName}/?${query}`, dbHeaders)
        .then((res) => {
          if (res.data && res.data.length) {
            res.data.forEach((element) => {
              element.value = element[valueProp ? valueProp : "id"];
              element.label = element[labelProp ? labelProp : "name"];
            });
            resolve(res.data);
          } else resolve(null);
        })
        .catch((error) => {
          console.log("Error", error);
          resolve(error);
        });
    } else resolve(null);
  });
}

export function getSingleEntry(dbUrl, dbHeaders, apiName, entry, fieldList) {
  return new Promise((resolve) => {
    let fields = "";
    if (entry && fieldList) {
      fields = "?fields=" + fieldList;
    }
    if (entry) {
      axios
        .get(dbUrl + `${apiName}/${entry}/${fields}`, dbHeaders)
        .then((res) => {
          if (res && res.data) {
            resolve(res.data);
          } else resolve(null);
        })
        .catch((error) => {
          resolve(error);
        });
    } else resolve(null);
  });
}
export function patchEntry(dbUrl, dbHeaders, apiName, entryId, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  console.log("Do we reutrn all res.data?", isIdReturned);
  return new Promise((resolve) => {
    axios
      .patch(dbUrl + `${apiName}/${entryId}/`, entryObject, updatedHeaders)
      .then((res) => {
        if (res && res.data) {
          console.log("here is res.data", res.data);
          if (isIdReturned) {
            resolve(res.data.id);
          } else resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}
export function postEntry(dbUrl, dbHeaders, apiName, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  return new Promise((resolve) => {
    axios.post(dbUrl + `${apiName}/`, entryObject, updatedHeaders).then((res) => {
      if (res && res.data) {
        if (isIdReturned) {
          resolve(res.data.id);
        } else resolve(res.data);
      } else resolve(null);
    });
    // .catch((error) => {
    //   throw error;
    //   // resolve(error);
    // });
  });
}

export function putEntry(dbUrl, dbHeaders, apiName, entryObject, isIdReturned) {
  const updatedHeaders = updateHeadersWithContentLength(dbHeaders, entryObject);
  return new Promise((resolve) => {
    axios.put(dbUrl + `${apiName}/`, entryObject, updatedHeaders).then((res) => {
      if (res && res.data) {
        if (isIdReturned) {
          resolve(res.data.id);
        } else resolve(res.data);
      } else resolve(null);
    });
    // .catch((error) => {
    //   throw error;
    //   // resolve(error);
    // });
  });
}

export function deleteEntry(dbUrl, dbHeaders, apiName, entryId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(dbUrl + `${apiName}/${entryId}/`, dbHeaders)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function postExternalEntry(dbUrl, apiName, entryObject, isIdReturned) {
  return new Promise((resolve) => {
    axios
      .post(dbUrl + `${apiName}/`, entryObject)
      .then((res) => {
        if (res && res.data) {
          if (isIdReturned) {
            resolve(res.data.id);
          } else resolve(res.data);
        } else resolve(null);
      })
      .catch((error) => {
        resolve(error);
      });
  });
}

export const retrieveAppSubscriptions = async (dbUrl, dbHeaders, userId, operatorId, getPartnerDefault, appType = "dock") => {
  let apiName = getPartnerDefault ? "partner-app-subscriptions" : "person-app-subscriptions";
  let query = `app_type=${appType}`;
  if (getPartnerDefault) {
    query = query + "&is_active=True&partner=" + operatorId;
  } else {
    query = query + "&user=" + userId;
  }
  let fieldList = "app_name"; //'id,person,app_feature,app_label,app_icon,app_type,app_size,app_purpose,app_name,app_description'
  let ordering = "app_order";
  let appList = await getAnimoAPI(dbUrl, dbHeaders, apiName, query, fieldList, ordering, null, operatorId, "partner");
  if (appList && appList.length) {
    return appList;
  }
};

export const retrieveAllAppSubscriptions = async (dbUrl, dbHeaders, userId, operatorId, appType = "dock") => {
  // Define common query parameters
  let query = `app_type=${appType}`;
  let fieldList = "app_name"; // Adjust this as needed
  let ordering = "app_order";

  // Fetch partner app subscriptions
  let partnerQuery = query + `&is_active=True&partner=${operatorId}`;
  let partnerAppList = await getAnimoAPI(dbUrl, dbHeaders, "partner-app-subscriptions", partnerQuery, fieldList, ordering, null, operatorId, "partner");

  // Fetch person app subscriptions
  let personQuery = query + `&active=True&user=${userId}`;
  let personAppList = await getAnimoAPI(dbUrl, dbHeaders, "person-app-subscriptions", personQuery, fieldList, ordering, null, operatorId, "partner");

  // Combine both app lists
  let combinedAppList = [...(partnerAppList || []), ...(personAppList || [])];

  // Remove duplicates based on 'app_name' (or another unique identifier if needed)
  let uniqueAppList = combinedAppList.reduce((acc, current) => {
    if (!acc.find((app) => app.app_name === current.app_name)) {
      acc.push(current);
    }
    return acc;
  }, []);

  // Return the unique app list
  return uniqueAppList;
};
